export const InappBrowser = {
  LINE: 'line',
  FACEBOOK: 'facebook',
  INSTAGRAM: 'instagram',
  THREADS: 'threads',
  TIKTOK: 'tiktok',
  WECHAT: 'wechat',
  TWITTER: 'twitter',
  LINKEDIN: 'linkedin',
  KAKAOTALK: 'kakaotalk',
  SNAPCHAT: 'snapchat',
  WEIBO: 'weibo',
  /** 視為正常瀏覽器 */
  NONE: 'none',
} as const

export type InappBrowserType = typeof InappBrowser[keyof typeof InappBrowser]

export const DIALOG_INAPP_BROWSER_GUIDE = 'DIALOG_INAPP_BROWSER_GUIDE'

export const inappBrowserInterceptEnabledMap = {
  [InappBrowser.LINE]: false,
  [InappBrowser.FACEBOOK]: true,
  [InappBrowser.INSTAGRAM]: false,
  [InappBrowser.THREADS]: false,
  [InappBrowser.TIKTOK]: false,
  [InappBrowser.WECHAT]: false,
  [InappBrowser.TWITTER]: false,
  [InappBrowser.LINKEDIN]: false,
  [InappBrowser.KAKAOTALK]: false,
  [InappBrowser.SNAPCHAT]: false,
  [InappBrowser.WEIBO]: false,
} satisfies Record<Exclude<InappBrowserType, typeof InappBrowser.NONE>, boolean>

export const inappBrowserDisplayNameMap = {
  [InappBrowser.LINE]: 'LINE',
  [InappBrowser.FACEBOOK]: 'Facebook',
  [InappBrowser.INSTAGRAM]: 'Instagram',
  [InappBrowser.THREADS]: 'Threads',
  [InappBrowser.TIKTOK]: 'TikTok',
  [InappBrowser.WECHAT]: 'WeChat',
  [InappBrowser.TWITTER]: 'X',
  [InappBrowser.LINKEDIN]: 'LinkedIn',
  [InappBrowser.KAKAOTALK]: 'KakaoTalk',
  [InappBrowser.SNAPCHAT]: 'Snapchat',
  [InappBrowser.WEIBO]: 'Weibo',
} satisfies Record<Exclude<InappBrowserType, typeof InappBrowser.NONE>, string>

export const GUIDE_TRIGGER = {
  ADD_TO_CART: 'add-to-cart',
  LOGIN_PAGE: 'login-page',
  CART_PAGE: 'cart-page',
  CHECKOUT_PAGE: 'checkout-page',
  ORDER_PAY_PAGE: 'order-pay-page',
} as const

export type GuideTriggerType = typeof GUIDE_TRIGGER[keyof typeof GUIDE_TRIGGER]

interface PageEntryRule {
  trigger: GuideTriggerType
  patterns: string[]
}

export const INAPP_BROWSER_GUIDE_PAGE_ENTRY_RULES: PageEntryRule[] = [
  { trigger: GUIDE_TRIGGER.CART_PAGE, patterns: ['{/:countryCode}/cart'] },
  { trigger: GUIDE_TRIGGER.ORDER_PAY_PAGE, patterns: ['{/:countryCode}/checkout/order-pay/*path'] },
  { trigger: GUIDE_TRIGGER.CHECKOUT_PAGE, patterns: ['{/:countryCode}/checkout'] },
  { trigger: GUIDE_TRIGGER.LOGIN_PAGE, patterns: ['{/:countryCode}/my-account'] },
]

export interface InappBrowserGuideDialogPayload {
  trigger: GuideTriggerType
  variationId?: number
}
